<script setup lang="js">
import {ref} from "vue";
import ContextColors from "@/components/ContextColors.vue";
import Context from "@/components/Context.vue";
import JustCreateTitle from "@/components/JustCreateTitle.vue";

const jcdt = ref("https://cos5.51tgqj.com/techming/img/jcdt@2x.png");
const btwcc = ref("https://cos5.51tgqj.com/techming/img/btwcc@2x.png");
const ypd = ref("https://cos5.51tgqj.com/techming/img/5ypd@2x.png");
</script>

<template>
<div>
  <context-colors color="bg-[#ffffff]" class="flex justify-center text-center">
    <el-image :src="jcdt" class="w-2/3"/>
  </context-colors>
  <context>
    <just-create-title text="铭匠动态"/>
    <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
      <div class="md:w-3/4 p-5 lg:w-4/6">
        <el-image :src="ypd" class="md:w-full" fit="contain"/>
      </div>
      <div class="md:w-full">
        <div class=" basis-1/2 p-4 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] text-white content-center ">
          <div>● 才聚賨城 职等你来！2025年广安夏季招聘会新鲜出炉。</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   走！去开辟新赛道</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   川渝高竹新区数智零工市场：点亮就业新灯塔，驱动双城新引擎</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   邻水：创业就业持续“给力” 暖了民心添了信心</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   前锋直聘——就业不用去远方 前锋就是好地方</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   家门口的创业梦，白塔微创园等您来！</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   九龙后街数智零工驿站：社区就是孵化器 邻里都是合伙人</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   睦春风——社区“新柒柿”，等你大展拳脚。</div>
          <div class="mt-2 md:mt-2 lg:mt-4">●   手把手教您直播，居家创业不是梦。</div>
        </div>
      </div>
    </div>
    <just-create-title text="客户服务"/>
    <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
      <div class="md:w-3/4 p-5 lg:w-4/6">
        <el-image :src="btwcc" class="md:w-full" fit="contain"/>
      </div>
      <div class="md:w-full text-white">
        <div class="text-3xl md:text-3xl lg:text-[1.8rem]">
          招募！白塔社区微创园招募创业者入驻。
        </div>
        <div class="mt-4 text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem] leading-10">
          　　白塔微创园是由广安市人社部门、街道、社区共同打造，重点为周边居民提供便捷的就业创业服务的平台。　　只要您有创业梦想，我们都能给您免费提供入驻机会和良好办公环境，倾心为您提供创业指导、创业补贴、担保贷款、法律咨询、市场推广等一站式服务。欢迎科技、文创、电商、社区服务等多领域的创业者积极入驻。
        </div>
      </div>
    </div>



    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   来体验！伴学喵社区自习室启动运营。</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   招聘！安迅科技招募标注项目经理。</div>
      <div>2025-05-12</div>
    </div>
   <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   好就业！新能源是您的期待。</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   优品！供销带你看好货.</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   前锋直聘——就业不用去远方 前锋就是好地方</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   家门口的创业梦，白塔微创园等您来！</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white  text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div class="">●   九龙后街数智零工驿站：社区就是孵化器 邻里都是合伙人</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>●   睦春风——社区“新柒柿”，等你大展拳脚。</div>
      <div>2025-05-12</div>
    </div>
    <div class="mt-4 flex flex-row justify-between text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
      <div>● 手把手教您直播，居家创业不是梦。</div>
      <div>2025-05-12</div>
    </div>


  </context>


</div>
</template>

<style scoped>

</style>
